var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M2 18.4V7.593A.8.8 0 0 1 2.263 7L9.597.364a.6.6 0 0 1 .806 0L17.737 7a.8.8 0 0 1 .263.593V18.4a.6.6 0 0 1-.6.6h-5.8a.6.6 0 0 1-.6-.6v-5.432H9V18.4a.6.6 0 0 1-.6.6H2.6a.6.6 0 0 1-.6-.6m8-15.694L4 8.134v8.855h3v-6.031h6v6.031h3V8.134z"
})));
export default SvgIconHome;